// Componente Siniestros.vue
<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="6"> </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTableData"
                  :data="datasiniestro"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >
                    <template slot-scope="scope">
                  <div v-if="title.prop == 'poliza'">  
                    <b-link type="text" 
                            v-if="scope.row.poliza > 0" 
                            @click="recuperar_detpoliza(scope.row.poliza, null, 0)"
                            >
                      {{scope.row.poliza}}
                    </b-link>
                    <p v-else >{{scope.row.poliza}}</p>
                  </div>
                  <p v-else>{{scope.row[title.prop]}}</p>
                </template>
                  </el-table-column>

                  <el-table-column  label="" min-width="100px" align="center">
                      <template slot-scope="scope">
                        <b-button size="sm" variant="primary" @click="recuperar_detsiniestro(scope.row.poliza)">Detalle</b-button>
                      </template>
                  </el-table-column>
                 
                  
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      title="Detalle Siniestro"
      cancel-title="Cancelar"
      v-model="modaldetsiniestro"
      @cancel="modaldetsiniestro = false"
    >
    <b-row class="my-1">
      <b-col sm="6"></b-col>
      <b-col sm="6">
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroNombre"
            type="text"
            placeholder="Buscar"
            v-model="filters[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="datadetsiniestro"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps"
            :filters="filters"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titlesdetsiniestro"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>


    <b-modal
      size="xl"
      scrollable
      hide-footer
      title="Detalle Siniestro"
      cancel-title="Cancelar"
      v-model="modaldetsiniestro"
      @cancel="modaldetsiniestro = false"
    >
    <b-row class="my-1">
      <b-col sm="6"></b-col>
      <b-col sm="6">
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroNombre"
            type="text"
            placeholder="Buscar"
            v-model="filters[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="datadetsiniestro"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps"
            :filters="filters"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titlesdetsiniestro"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">
              <template slot-scope="scope">
                  <div v-if="title.prop == 'sujriesgo'">  
                    <b-link type="text" 
                            v-if="scope.row.sujriesgo > 0" 
                            @click="selecciona_receptor(scope.row.sujriesgo)"
                            >
                      {{scope.row.sujriesgo}}
                    </b-link>
                    <p v-else >{{scope.row.receptor}}</p>
                  </div>
                  <p v-else>{{scope.row[title.prop]}}</p>
                </template>
            </el-table-column>

            <el-table-column  label="" min-width="110px" align="center">
              <template slot-scope="scope">
                <b-button size="sm" variant="primary" @click="recuperar_liqsiniestro(scope.row.siniestro)">Liquidaciones</b-button>
              </template>
            </el-table-column>

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      :title= 'titlemodalliqsin'
      cancel-title="Cancelar"
      v-model="modalliqsiniestro"
      @cancel="modalliqsiniestro = false"
    >
    <b-row class="my-1">
      <b-col sm="6"></b-col>
      <b-col sm="6">
        <b-form-group label label-for="filtroProceso">
          <b-form-input
            id="filtroNombre"
            type="text"
            placeholder="Buscar"
            v-model="filters[0].value"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br>

    <b-row>
      <b-col lg="12">             
        <div ref="refTable2">
          <data-tables ref="refTable2"
            :data="dataliqsiniestro"
            name="table1"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps"
            :filters="filters"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table">
            <el-table-column
              v-for="title in titlesliqsiniestro"
              :min-width="title.minwidth" 
              :prop="title.prop"
              :label='title.label'
              :key="title.label"
              :align="title.align"
              sortable="custom"
              :formatter="formatter"
              name="table"
              class="table-responsive">

              <template slot-scope="scope">
                  <div v-if="title.prop == 'receptor'">  
                    <b-link type="text" 
                            v-if="scope.row.receptor > 0" 
                            @click="selecciona_receptor(scope.row.receptor)"
                            >
                      {{scope.row.receptor}}
                    </b-link>
                    <p v-else >{{scope.row.receptor}}</p>
                  </div>
                  <p v-else>{{scope.row[title.prop]}}</p>
                </template>


            </el-table-column>
            

          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      title= "Datos de la Persona"
      cancel-title="Cancelar"
      v-model="modalPersona"
      @cancel="modalPersona = false"
    >
      <Persona ref="detPersona"
               :cod_asegurado = "this.receptor">
      </Persona>

    </b-modal>

    <b-modal
      size="xl"
      scrollable
      hide-footer
      title="Detalle Póliza"
      cancel-title="Cancelar"
      v-model="modaldetpoliza"
      @cancel="modaldetpoliza = false"
    >
        <center><h5>COPIA NO VALIDA</h5></center>
        <p><b>Riesgo: </b> {{ this.datosFormulario.producto }} </p>
        <p><b>Póliza: </b> {{ this.datosFormulario.poliza }} <b>Propuesta:</b> {{ this.datosFormulario.propuesta }} <b>Sucursal:</b> {{ this.datosFormulario.sucursal }} </p>
        <p><b>Moneda: </b> {{ this.datosFormulario.moneda }} </p>
        <p><b>Corredor: </b> {{ this.datosFormulario.corredor }} <b>Rut: </b> {{ this.datosFormulario.rutnumcorred }}-{{ this.datosFormulario.rutdvcorred}} <b>Código: </b> {{ this.datosFormulario.codigocorred}}</p>
        <p><b>Contratante: </b> {{ this.datosFormulario.contratante }} <b>Rut: </b> {{ this.datosFormulario.rutnumcon }}-{{ this.datosFormulario.rutdvcon}}</p>
        <p><b>Dirección: </b> {{ this.datosFormulario.direccon }} </p>
        <p><b>Item: </b> {{ this.datosFormulario.item }} <b>Endoso: </b> {{ this.datosFormulario.endoso }}</p>
        <p><b>Asegurado: </b> {{ this.datosFormulario.asegurado }} <b>Rut: </b>{{ this.datosFormulario.rutnumaseg}}-{{ this.datosFormulario.rutdvaseg}}</p>
        <p><b>Dirección: </b> {{ this.datosFormulario.direcaseg }} </p>
        <p><b>Vig. Desde: </b> {{ this.datosFormulario.vigdesde }} <b>Vig. Hasta: </b> {{ this.datosFormulario.vighasta }}</p>
        <p><b>Acción: </b> {{ this.datosFormulario.accion }} </p>
        <br>
        <table class="table">
          <tr>
          <td align ="center"><b>Monto asegurado</b></td>		<td align ="center"><b>Prima neta</b></td>	<td align ="center"><b>IVA</b></td>
          </tr>
          <tr>
          <td align ="center">{{this.datosFormulario.montoaseg}}</td>		<td align ="center">{{this.datosFormulario.primaneta}}</td>	<td align ="center">{{this.datosFormulario.iva}}</td>
          </tr>
        </table>
        <br>
        <center><p><b>Detalle de Materia Asegurada</b></p></center>
        <p>{{this.datosFormulario.materia}}</p>
        <br>
        <p><b>Póliza</b> {{ this.datosFormulario.poliza }} <b>Endoso</b> {{ this.datosFormulario.endoso }} <b>Item</b> {{ this.datosFormulario.item }}  </p>
        <p><b>Firma Autorizada</b> </p>
        <br>
        <center><p><b>Observaciones</b></p></center>
        {{this.datosFormulario.observaciones}}

      
      <b-row>
    
      </b-row>
    </b-modal>

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import Persona from './persona.vue';


export default {
  name: "Siniestros",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    cod_asegurado: Number,
    participacion: Number,
    
  },

  components:{
    Persona
  },

  data: function() {

    return {
      datasiniestro:[],
      datadetsiniestro:[],
      dataliqsiniestro:[],
      titlemodalliqsin: "",
      
      busqueda: "",
      receptor:"",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      modaldetsiniestro: false,
      modalliqsiniestro: false,
      modaldetpoliza: false,
      modalPersona: false,
      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },
      
      datosFormulario: {
        producto: "",
        poliza: "",
        endoso: "",
        item: "",
        propuesta: "",
        accion: "",
        moneda: "",
        vigdesde: "",
        vighasta: "",
        montoaseg: "",
        primaneta: "",
        iva: "",
        materia: "",
        sucursal: "",
        corredor: "",
        rutnumcorred: "",
        rutdvcorred: "",
        codigocorred: "",
        asegurado: "",
        direcaseg: "",
        ciudadaseg: "",
        rutnumaseg: "",
        rutdvaseg: "",
        contratante: "",
        rutnumcon: "",
        rutdvcon: "",
        direccon: "",
        ciudadcon: "",
        observaciones: "",
      },
      

      titles: [
        {
          prop: "producto",
          label: "Producto",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "totliquidado",
          label: "Total Liquidado",
          align: "right",
          minwidth:'150'
        },      
        {
          prop: "totrecuperado",
          label: "Total Recuperado",
          align: "right",
          minwidth:'150'
        },      
        {
          prop: "totprovision",
          label: "Total Provisión",
          align: "right",
          minwidth:'150'
        }
        
      ],

      titlesdetsiniestro: [
        {
          prop: "siniestro",
          label: "Nro. Siniestro",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "fesiniestro",
          label: "Fecha Siniestro",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "fedenuncio",
          label: "Fecha Denuncio",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'60'
        },      
        {
          prop: "mtoliquidado",
          label: "Monto Liquidado",
          align: "right",
          minwidth:'90'
        },      
        {
          prop: "mtorecupero",
          label: "Monto Recuperado",
          align: "right",
          minwidth:'90'
        },      
        {
          prop: "mtoprovision",
          label: "Monto Provisión",
          align: "right",
          minwidth:'90'
        },      
        {
          prop: "tipo",
          label: "Tipo",
          align: "center",
          minwidth:'80'
        }, 
        {
          prop: "sujriesgo",
          label: "Suj. Riesgo",
          align: "center",
          minwidth:'80'
        },     
        {
          prop: "rut",
          label: "Rut",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "nomsujeto",
          label: "Nombre Sujeto",
          align: "center",
          minwidth:'200'
        }
      ],

      titlesliqsiniestro: [
        {
          prop: "tipo",
          label: "Tipo",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "receptor",
          label: "Receptor",
          align: "center",
          minwidth:'100'
        },
        {
          prop: "nombrereceptor",
          label: "Nombre Receptor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "tiporeceptor",
          label: "Tipo Receptor",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "feliquidacion",
          label: "Fecha Liquidación",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "fepago",
          label: "Fecha Pago",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "moneda",
          label: "Moneda",
          align: "center",
          minwidth:'100'
        },      
        {
          prop: "montoneto",
          label: "Monto Neto",
          align: "right",
          minwidth:'100'
        },      
        {
          prop: "estado",
          label: "Estado",
          align: "center",
          minwidth:'100'
        }
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

    }
  },
  methods: {
    
    formatter(row, column) {
      if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
    },

    recuperar_siniestro() {
      this.$Progress.start(); 
      return apiConsultaCliente
        .recuperar_siniestro(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.cod_asegurado,
          this.participacion
          )  
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.datasiniestro = response.data.res;
            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= error;
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },

    recuperar_detsiniestro(p_poliza) {
         console.log(p_poliza);
      this.$Progress.start(); 
      return apiConsultaCliente
          .recuperar_detsiniestro(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.cod_asegurado,
            this.participacion,
            p_poliza

            )  
            .then(response => {
              this.modaldetsiniestro = true;            
              response.data = this.keysMinuscula(response.data);
              this.datadetsiniestro = response.data.res;
              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
      },

      recuperar_liqsiniestro(p_siniestro) {
        
        this.$Progress.start(); 
        return apiConsultaCliente
          .recuperar_liqsiniestro(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            p_siniestro
            )  
            .then(response => {
              this.modalliqsiniestro = true;            
              response.data = this.keysMinuscula(response.data);
              this.dataliqsiniestro = response.data.res;
              console.log(this.dataliqsiniestro);

              this.titlemodalliqsin = "Liquidaciones del Siniestro Nº " + p_siniestro;
              
              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
      },

      selecciona_receptor(p_receptor){
        
        this.receptor = p_receptor;
        this.modalPersona = true;
        // console.log(p_receptor);

      },
      
      recuperar_detpoliza(p_poliza, p_item, p_endoso) {
          console.log(p_poliza, p_item, p_endoso);
            this.$Progress.start(); 
           
            return apiConsultaCliente
              .recuperar_detpoliza(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                p_poliza,
                p_item,
                p_endoso
              )  
              .then(response => {
                this.modaldetpoliza = true;
                
                response.data = this.keysMinuscula(response.data);
                var datadetpoliza = response.data.res;
                // console.log(datadetpoliza);
                for (var i = 0; i < datadetpoliza.length; i++) {

                  this.datosFormulario.producto = datadetpoliza[i]["producto"];
                  this.datosFormulario.poliza = datadetpoliza[i]["poliza"];
                  this.datosFormulario.endoso = datadetpoliza[i]["endoso"];
                  this.datosFormulario.item = datadetpoliza[i]["item"];
                  this.datosFormulario.propuesta = datadetpoliza[i]["propuesta"];
                  this.datosFormulario.accion = datadetpoliza[i]["accion"];
                  this.datosFormulario.moneda = datadetpoliza[i]["moneda"];
                  this.datosFormulario.vigdesde = datadetpoliza[i]["vigdesde"];
                  this.datosFormulario.vighasta = datadetpoliza[i]["vighasta"];
                  this.datosFormulario.montoaseg = datadetpoliza[i]["montoaseg"];
                  this.datosFormulario.primaneta = datadetpoliza[i]["primaneta"];
                  this.datosFormulario.iva = datadetpoliza[i]["iva"];
                  this.datosFormulario.materia = datadetpoliza[i]["materia"];
                  this.datosFormulario.sucursal = datadetpoliza[i]["sucursal"];
                  this.datosFormulario.corredor = datadetpoliza[i]["corredor"];
                  this.datosFormulario.rutnumcorred = datadetpoliza[i]["rutnumcorred"];
                  this.datosFormulario.rutdvcorred = datadetpoliza[i]["rutdvcorred"];
                  this.datosFormulario.codigocorred = datadetpoliza[i]["codigocorred"];
                  this.datosFormulario.asegurado = datadetpoliza[i]["asegurado"];
                  this.datosFormulario.direcaseg = datadetpoliza[i]["direcaseg"];
                  this.datosFormulario.ciudadaseg = datadetpoliza[i]["ciudadaseg"];
                  this.datosFormulario.rutnumaseg = datadetpoliza[i]["rutnumaseg"];
                  this.datosFormulario.rutdvaseg = datadetpoliza[i]["rutdvaseg"];
                  this.datosFormulario.contratante = datadetpoliza[i]["contratante"];
                  this.datosFormulario.rutnumcon = datadetpoliza[i]["rutnumcon"];
                  this.datosFormulario.rutdvcon = datadetpoliza[i]["rutdvcon"];
                  this.datosFormulario.direccon = datadetpoliza[i]["direccon"];
                  this.datosFormulario.ciudadcon = datadetpoliza[i]["ciudadcon"];
                  this.datosFormulario.observaciones = datadetpoliza[i]["observacion"];

                }
                
                this.$Progress.finish();
              })
              .catch(error => {
                this.mensaje= "Error";
                this.variant="warning";
                this.showAlert = true;
                this.$Progress.finish();
              });
      },
  },
      
  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_siniestro();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>